export class AglCategoryTypes {
    public static ActionInitiated = 'ActionInitiated';
    public static ActionError = 'ActionError';
    public static AuthenticationError = 'AuthenticationError';
    public static AuthorizationError = 'AuthorizationError';
}
